import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import Insta from '../../styles/social/instagram';
import Facebook from '../../styles/social/facebook';
import LinkedIn from '../../styles/social/linkedin';

import Logo1 from './images/stv_logo.png';

import Styles from './styles';

import useI18n from '../../utils/use-i18n';
import ContentEnglish from './i18n/en';
import ContentSpanish from './i18n/es';

const content = {
    en: ContentEnglish,
    es: ContentSpanish,
};

const Footer = ({ classes }) => (
    <footer>
        <section className={classes.blueWrapper}>
            <div className="container">
                <div className={`row pt-5 ${classes.videoRow}`}>
                    <div className="col">
                        <div
                            style={{
                                padding: '56.25% 0 0 0',
                                position: 'relative',
                            }}>
                            <iframe
                                src="https://player.vimeo.com/video/1226736857?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                                allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                                referrerPolicy="strict-origin-when-cross-origin"
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                }}
                                title="Read The F*ing Directions - PSA 1"
                                aria-hidden
                            />
                        </div>
                    </div>
                </div>
                <div className="row pt-4">
                    <div className="col">
                        <hr className={classes.hr} />
                        <Typography
                            variant="h4"
                            component="h2"
                            className={classes.title}>
                            {useI18n('title', content)}
                        </Typography>
                        <hr className={classes.hr} />
                    </div>
                </div>
                <div className="row pt-4 pb-5">
                    <div className="col">
                        <Typography variant="body1">
                            {useI18n('description', content)}
                            &nbsp;Learn more&nbsp;
                            <a
                                href="https://www.nationalcivicleague.org/spread-the-vote/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className={classes.textLink}>
                                here
                            </a>
                            , and{' '}
                            <a
                                href="https://nationalcivicleague.app.neoncrm.com/np/clients/nationalcivicleague/subscribe.jsp?subscription=5"
                                target="_blank"
                                rel="noopener noreferrer"
                                className={classes.textLink}>
                                sign up for our newsletter
                            </a>{' '}
                            for updates on our work.
                        </Typography>
                    </div>
                </div>
            </div>
        </section>
        <section className={classes.blackWrapper}>
            <div className="container">
                <div className="row">
                    <div className="col-md">
                        <a
                            href="https://www.spreadthevote.org/"
                            rel="noopener noreferrer"
                            target="_blank"
                            className={classes.logoBlock}
                            aria-label="Spread The Vote">
                            <img
                                src={Logo1}
                                alt="Spread The Vote Logo"
                                style={{
                                    height: 'auto',
                                    maxWidth: 250,
                                }}
                            />
                        </a>
                    </div>
                </div>
                <div className="row pt-5">
                    <div className="col text-center">
                        <a
                            className={classes.socialBlock}
                            aria-label="Follow us on Instagram"
                            href="https://www.instagram.com/spreadthevotencl/"
                            target="_blank"
                            rel="noopener noreferrer">
                            <Insta />
                        </a>
                        <a
                            className={classes.socialBlock}
                            aria-label="Follow us on Facebook"
                            href="https://www.facebook.com/spreadthevotencl"
                            target="_blank"
                            rel="noopener noreferrer">
                            <Facebook />
                        </a>
                        <a
                            className={classes.socialBlock}
                            aria-label="Follow us on LinkedIn"
                            href="https://www.linkedin.com/company/spread-the-vote"
                            target="_blank"
                            rel="noopener noreferrer">
                            <LinkedIn />
                        </a>
                    </div>
                </div>
                <div className="row pt-3">
                    <div className="col text-center">
                        <Typography variant="body1" style={{ fontSize: 13 }}>
                            &copy;2026 Spread The Vote
                        </Typography>
                    </div>
                </div>
            </div>
        </section>
    </footer>
);

Footer.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(Styles)(Footer);
